module.exports = "/assets/data/3347c3e9137e56086fab6efa95e54f7a-SE25.data.json";